import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, LeafIcon, SparklesIcon, HeartIcon } from 'lucide-react';
export function DecisionSection() {
  const benefits = [{
    text: 'Hacen el plan más fácil de seguir',
    icon: CheckCircleIcon
  }, {
    text: 'Eliminan la confusión sobre qué comer',
    icon: LeafIcon
  }, {
    text: 'Ayudan a mantener la constancia',
    icon: HeartIcon
  }, {
    text: 'Agregan variedad a tu alimentación',
    icon: SparklesIcon
  }];
  return <section className="py-24 bg-[#EDE4D6]/50 backdrop-blur-[2px]" data-id="element-307">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-308">
        <motion.h2 className="text-3xl md:text-4xl font-heading font-semibold text-text-dark text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-309">
          Por qué estos bonos ayudan a obtener mejores resultados
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-310">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-beige flex items-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-311">
                <div className="w-12 h-12 rounded-full bg-sage-50 flex items-center justify-center mr-4 flex-shrink-0 text-sage" data-id="element-312">
                  <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-313" />
                </div>
                <span className="font-medium text-text-dark text-lg" data-id="element-314">
                  {benefit.text}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}